import { render, staticRenderFns } from "./PagamentosEletronicosFinanceiroPagamentosEletronicosView.vue?vue&type=template&id=16b05aff&scoped=true"
import script from "./PagamentosEletronicosFinanceiroPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PagamentosEletronicosFinanceiroPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagamentosEletronicosFinanceiroPagamentosEletronicosView.vue?vue&type=style&index=0&id=16b05aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b05aff",
  null
  
)

export default component.exports